import { RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { Controller, UseFormReturn } from "react-hook-form";
import { DisciplinaChecklistForm } from "../../../schemas/CronogramaItensChecklist_cadastro/checklist_item";

export const GenerateProjetoColumnDefinition = (hookForm: UseFormReturn<DisciplinaChecklistForm>): GridColDef[] => [
  {
    field: "itens",
    headerName: "Itens",
    width: 80,
  },
  {
    field: "descricao",
    headerName: "Descrição",
    flex: 1,
  },
  {
    field: "inspecao",
    headerName: "Inspeção",
    flex: 1,
    renderCell: (params) => {
      const itens = hookForm.watch("itens");
      const index = itens?.findIndex((i) => i.idDisciplinaItensChecklist === params.row.idDisciplinaItemChecklist);
      if (index === undefined || index < 0) return null;

      return (
        <Controller
          control={hookForm.control}
          name={`itens.${index}.inspecao`}
          render={({ field }) => (
            <RadioGroup row {...field}>
              <FormControlLabel
                value="C"
                control={<Radio />}
                label="C"
                sx={{
                  "& .MuiFormControlLabel-label": {
                    backgroundColor: "#26A69A",
                    padding: "2px 8px",
                    borderRadius: "12px",
                    color: "#fff",
                    fontWeight: 500,
                  },
                }}
              />
              <FormControlLabel
                value="NC"
                control={<Radio />}
                label="NC"
                sx={{
                  "& .MuiFormControlLabel-label": {
                    backgroundColor: "#EF5350",
                    padding: "2px 8px",
                    borderRadius: "12px",
                    color: "#fff",
                    fontWeight: 500,
                  },
                }}
              />
              <FormControlLabel
                value="NA"
                control={<Radio />}
                label="NA"
                sx={{
                  "& .MuiFormControlLabel-label": {
                    backgroundColor: "#9E9E9E",
                    padding: "2px 8px",
                    borderRadius: "12px",
                    color: "#fff",
                    fontWeight: 500,
                  },
                }}
              />
            </RadioGroup>
          )}
        />
      );
    },
  },
];
